import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./lib/auth";
import { TenantProvider } from "./lib/tenant";
import { capturePendingJoinFromUrl } from "./lib/pendingJoin";
import { captureRedirectFromUrl } from "./lib/redirectAfter";
import "./index.css";

// Capturar querystring intent ANTES de que el router corra cualquier redirect.
capturePendingJoinFromUrl();
captureRedirectFromUrl();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <TenantProvider>
          <App />
        </TenantProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
